module.exports = __webpack_public_path__ + "static/media/navigation.bd51c294.svg";